var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryAndElectrical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.478 15.246h34.7a1.15 1.15 0 0 1 1.15 1.15v22.203h-37V16.392a1.15 1.15 0 0 1 1.15-1.146zM19.267 12h-8.282v3.245h8.282V12zM37.81 12h-8.283v3.245h8.282V12z",
    stroke: "currentColor",
    strokeWidth: "0.04em",
    strokeMiterlimit: "0.2em"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.316 26.918h10.38M9.935 26.918h10.38M15.123 21.728v10.377",
    stroke: "currentColor",
    strokeWidth: "0.04em",
    strokeMiterlimit: "0.2em",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryAndElectrical);
export default __webpack_public_path__ + "static/media/battery-and-electrical.42ed4e1984b56e05bb2a1d16db11207c.svg";
export { ForwardRef as ReactComponent };